export default function checkArrayLength<T, N extends number>(
    arr: T[],
    size: N
): arr is Tuple<T, N> {
    return arr.length === size;
}
